"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewerEntityList = exports.setViewerEntityList = exports.urlBuilder = exports.unhandledErrorGenerator = exports.removeUsername = exports.getUsername = exports.setUsername = exports.fixNumbers = exports.arabicNumbers = exports.persianNumbers = exports.AUTH_FAILED_ERROR = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
exports.AUTH_FAILED_ERROR = 'AuthenticationFailed';
var fixNumbers = function (str) {
    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(exports.persianNumbers[i], i).replace(exports.arabicNumbers[i], i);
        }
    }
    return str;
};
exports.persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g], exports.arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g], exports.fixNumbers = fixNumbers;
const setUsername = async (username) => {
    try {
        return await async_storage_1.default.setItem('username', username);
    }
    catch {
        // saving error
    }
};
exports.setUsername = setUsername;
const getUsername = async () => {
    try {
        return await async_storage_1.default.getItem('username');
    }
    catch {
        // saving error
    }
};
exports.getUsername = getUsername;
const removeUsername = async () => {
    try {
        await async_storage_1.default.removeItem('username');
    }
    catch {
        // saving error
    }
};
exports.removeUsername = removeUsername;
const unhandledErrorGenerator = (code) => {
    return {
        title: 'خطا',
        message: `خطایی با کد ${code} رخ داده است! لطفا دوباره امتحان نمایید و در صورت تکرار با پشتیبانی تماس برقرار نمایید.`,
    };
};
exports.unhandledErrorGenerator = unhandledErrorGenerator;
const urlBuilder = ({ baseAddress, callType, authJson, params = '' }) => {
    return `${baseAddress}?CallType=${callType}${params ? `&${params}` : ''}${authJson ? `&AuthJson=${authJson}` : ''}`;
};
exports.urlBuilder = urlBuilder;
const setViewerEntityList = async (value) => {
    try {
        await async_storage_1.default.setItem('viewer-entity-list', JSON.stringify(value));
    }
    catch (e) {
        console.log('set entity type code in storage error', e);
    }
};
exports.setViewerEntityList = setViewerEntityList;
const getViewerEntityList = async () => {
    try {
        const value = await async_storage_1.default.getItem('viewer-entity-list');
        if (value)
            return JSON.parse(value);
    }
    catch (e) {
        console.log('get entity type code in storage error', e);
    }
    return [];
};
exports.getViewerEntityList = getViewerEntityList;
